import { Slugify } from '../../Admin/Functions/Slugify.js';

export const BreadTags = (props) => {
    const label = props.label;
    const datas = props.datas;
    let href, name;
    switch (label) {
        case 'archives':
        case 'characters':
        case 'experiments':
        case 'origins':
        case 'rencontres':
        default:
            return (
                <div className="breadtags">
                    {datas.map((el, i) => {
                        if (label === 'archives') {
                            href = el.cslug; name = el.cname; }
                        if (label === 'characters') {
                            href = Slugify(el.oname); name = el.oname; }
                        if (label === 'experiments') {
                            href = Slugify(el.name); name = `Série ${i}00`; }
                        if (label === 'origins') {
                            href = Slugify(el.otname); name = el.otname; }
                        if (label === 'rencontres') {
                            href = Slugify(el.oriname); name = el.oriname; }
                        return (
                            <a className="tag" href={`#${href}`} alt={name} key={i}>{`${name}`}</a>
                        )
                    })}
                </div>
            )
    }

}
